import { createStore } from 'zustand';
import { createContext } from 'react';

export type TOrderedProjectStore = {
  openProject: number;
  setOpenProject: (project: number) => void;
};

export function createOrderedProjectsStore() {
  return createStore<TOrderedProjectStore>((set) => ({
    openProject: -1,
    setOpenProject: (project: number) =>
      set((state) => ({
        openProject: project === state.openProject ? -1 : project,
      })),
  }));
}

export type TOrderedProjectsContext = ReturnType<
  typeof createOrderedProjectsStore
>;

export const OrderedProjectsContext = createContext<TOrderedProjectsContext>(
  null as unknown as TOrderedProjectsContext,
);
